<template>
  <div>
    <div class="card p-3 mb-2" v-for="p in pedidos">
      <div>
        <div class="float-right">
          <button class="btn btn-sm text-primary text-nowrap" @click="$emit('abrirPedido', p.id_pedido)">
            Visualizar <i class="fa fa-chevron-right ml-1"></i>
          </button>
        </div>
        <div>
          <h6 class="mb-0 font-weight-bold text-primary">{{p.nome_fantasia}}</h6>
          <p class="small m-0">
            <span v-if="p.id_contador">#{{p.id_contador}} - </span>LeCard: {{p.id_pedido}} <br>
            {{p.data_pedido}}
          </p>
          <p class="font-weight-bold m-0 small text-danger" v-if="p.status === '5'">
            Cancelado<span v-show="p.obs_cancelamento">: {{p.obs_cancelamento}}</span>
          </p>
          <div class="border-top text-center mt-3 pt-3" v-if="p.status === '4' && empresa.id_plano === '2'" @click="$emit('abrirPedido', p.id_pedido, true)">
            <button class="btn btn-block" :class="p.id_avaliacao ? 'btn-outline-primary' : 'btn-primary'">
              <span v-if="p.id_avaliacao"><i class="fa fa-check mr-1"></i> Ver avaliação</span>
              <span v-else><i class="fa fa-star mr-1"></i> Avaliar Pedido</span>
            </button>
          </div>
        </div>
      </div>
      <div class="mt-3" v-if="p.status < 4 && p.status_pagamento === '2'">
        <div class="text-center">
          <div class="loader mb-2" :class="p.status === '2' ? 't-50' : p.status === '3' ? 't-100' : ''"></div>
          <div class="small font-weight-bold mb-0" @click="acompanhePedido = !acompanhePedido">
            <span v-if="p.status === '1'">{{ p.data_agendamento ? 'Pedido agendado com sucesso' : 'Pedido sendo confirmado' }}</span>
            <span v-else-if="p.status === '2'">O pedido está sendo preparado</span>
            <span v-else-if="p.status === '3'">
              {{parseInt(p.tipo_pedido) === 1 ? 'O pedido saiu para entrega' : 'Pedido disponível para retirada'}}
            </span>
          </div>
        </div>
        <div class="text-muted mt-2">
          <div class="d-flex align-items-center py-1">
            <div class="mr-3">
              <i class="fa fa-check-circle" :class="p.data_aceitacao ? 'text-primary' : 'text-light'"></i>
            </div>
            <div class="small">
              <div class="d-block font-weight-bold mb-0">Pedido confirmado</div>
              <div>{{p.data_aceitacao}}</div>
            </div>
          </div>
          <div class="d-flex align-items-center py-1" v-if="parseInt(p.tipo_pedido) === 2">
            <div class="mr-3">
              <i class="fa fa-check-circle" :class="p.data_entrega ? 'text-primary' : 'text-light'"></i>
            </div>
            <div class="small">
              <div class="d-block font-weight-bold mb-0">Disponível para retirada</div>
              <div v-show="p.data_entrega">{{p.data_entrega}}</div>
            </div>
          </div>
          <div class="d-flex align-items-center py-1" v-if="parseInt(p.tipo_pedido) === 1">
            <div class="mr-3">
              <i class="fa fa-check-circle" :class="p.data_entrega ? 'text-primary' : 'text-light'"></i>
            </div>
            <div class="small">
              <div class="d-block font-weight-bold mb-0">Saiu para entrega</div>
              <div v-show="p.data_entrega">{{p.data_entrega}}</div>
            </div>
          </div>
          <div class="d-flex align-items-center py-1">
            <div class="mr-3">
              <i class="fa fa-check-circle" :class="p.data_finalizacao ? 'text-primary' : 'text-light'"></i>
            </div>
            <div class="small">
              <div class="d-block font-weight-bold">Pedido {{ parseInt(p.tipo_pedido) === 1 ? 'entregue' : 'finalizado' }}</div>
              <span v-show="p.data_finalizacao">{{p.data_finalizacao}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3" v-if="andamento">
        <div class="border rounded-lg p-2 text-center mb-3">
          <div v-if="!p.data_agendamento">
            <div v-show="parseInt(p.status) >= 2">Previsão {{parseInt(p.tipo_pedido) === 1 ? "de entrega" : "para retirar o pedido"}}: <b>{{getPrevisao(p)}}</b></div>
            <div class="small" v-if="p.status === '1'">Previsão disponível após o pedido ser aprovado.</div>
          </div>
          <div class="small mb-0" v-else>
            <div>Pedido Agendado: <b>{{p.data_agendamento}}</b></div>
            <div class="font-weight-bold" v-if="p.status > '1'">O agendamento do seu pedido já foi confirmado.</div>
          </div>
        </div>
        <div class="mb-3" v-if="p.descricao_pagamento">
          <div class="alert alert-warning m-0 small" style="white-space: pre-line">
            <h6 class="mb-0 text-normal">Detalhes do pagamento:</h6>
            <div v-html="p.descricao_pagamento"></div>
          </div>
        </div>
        <div class="mb-3" v-if="p.status_pagamento === '1'">
          <div class="small mb-1 text-center font-weight-bold">Realize o pagamento o pedido ser confirmado.</div>
          <button class="btn btn-primary btn-block" @click="pagarPedido(p)" :disabled="load">
            Pagar Pedido
          </button>
        </div>
      </div>
      <div class="border-top pt-3 mb-2" v-if="andamento">
        <div v-if="p.status === '1'">
          <div class="mb-3" v-if="p.whatsapp && !p.id_entrega && p.status_pagamento === '2' && empresa.chat_lecard !== '1'">
            <div class="font-weight-bold small text-center mb-2">Está demorando ser aprovado ?</div>
            <a href="javascript:" @click="enviarWhatsapp(p)" class="btn btn-success btn-block">
              Enviar por WhatsApp
            </a>
          </div>
          <button class="btn btn-outline-danger btn-block" @click="cancelarPedido(p)" :disabled="load">
            {{load ? 'Cancelando o pedido..' : 'Cancelar o pedido'}}
          </button>
        </div>
        <div v-else>
          <div class="font-weight-bold">Problemas com seu pedido?</div>
          <div class="small mb-2">Para cancelamentos, alterações ou reclamações, entre em contato com a gente:</div>
          <div v-if="empresa.chat_lecard === '1'">
            <a :href="`https://chat.lecard.delivery/pedido/${p.id_pedido}?t=${token}`" target="_blank" class="btn btn-block btn-outline-primary">
              <svg width="18" height="18" version="1.0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(0 512) scale(.1 -.1)">
                  <path d="m2335 5108c-498-50-997-296-1340-660-346-367-545-816-587-1321l-12-147-51-34c-114-77-240-232-285-354-55-147-55-143-55-642s0-495 55-642c66-178 260-372 438-438 140-53 159-55 473-55h295l41 27c22 15 51 44 64 65l24 38v1005 1005l-24 38c-13 21-42 50-64 65l-40 27-229 3-228 3v38c0 132 74 400 160 579 135 281 324 507 571 685 111 80 337 194 466 237 382 126 808 117 1177-26 450-174 810-521 997-961 23-54 50-110 61-125 59-84 191-100 281-34 35 25 77 110 77 153 0 76-121 336-240 515-444 671-1221 1037-2025 956zm-1335-3159v-741l-148 3c-148 4-148 4-224 41-91 45-147 103-191 196l-32 67v435 435l32 67c40 85 97 147 172 186 79 43 115 50 264 51l127 1v-741z"/>
                  <path d="m3858 3081c-42-14-84-48-110-89l-23-37-10-2220-24-38c-13-21-42-50-64-65l-40-27-344-3c-210-2-343 1-343 6 0 6-21 33-46 61-31 35-70 63-122 88-72 36-81 38-172 38s-100-2-172-37c-91-45-147-103-191-196-29-61-32-76-32-163 0-90 2-99 37-171 45-91 103-147 196-191 61-29 76-32 163-32 90 0 99 2 171 38 52 25 91 53 122 88 25 28 46 55 46 60s149 9 343 9c384 0 435 7 560 72 81 42 203 164 245 245 36 68 72 196 72 253v38l168 5c169 5 216 13 334 57 177 66 372 261 438 438 55 147 55 143 55 642s0 495-55 642c-29 77-104 191-175 261-68 70-184 148-263 177-136 51-153 53-452 56-157 2-297-1-312-5zm634-433c91-45 147-103 191-196l32-67v-435-435l-32-67c-44-93-100-151-191-196-76-37-76-37-224-41l-148-3v742 742l148-3c148-4 148-4 224-41z"/>
                </g>
              </svg>
              Fale com um atendente
            </a>
          </div>
          <div v-else>
            <a :href="'tel:' + p.telefone" class="btn btn-block btn-outline-primary">Ligar: <b>{{p.telefone | phone}}</b></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from "./Icon";
  export default {
    name: "Pedido",
    components: {Icon},
    props: ['pedidos', 'andamento'],

    data() {
      return {
        token: localStorage.getItem('token'),
        acompanhePedido: false,
        load: false,
        url: '',
      }
    },

    methods: {
      pagarPedido(p) {
        this.$emit('pagarPedido', p);
      },

      getPrevisao(p) {
        return this.empresa.unidade_tempo !== '3' ? p.previsao.slice(-5) : `${p.previsao.substring(0, 10)}`;
      },

      cancelarPedido(p) {
        if (p.whatsapp && !p.id_entrega && p.status_pagamento === '2' && this.empresa.chat_lecard !== '1') {
          this.$swal({
            text: 'Lamentamos a demora em aceitar o seu pedido! Quer nos enviar por WhatsApp?',
            buttons: ["Cancelar pedido", "Enviar por WhatsApp"],
            dangerMode: false,
          }).then((r) => {
            if (r) {
              this.enviarWhatsapp(p);

            } else {
              this.solicitarCancelamento(p);
            }
          });

        } else {
          this.solicitarCancelamento(p);
        }
      },

      solicitarCancelamento(p) {
        this.$swal({
          text: 'Deseja realmente cancelar o pedido?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.cancelar(p);
          }
        });
      },

      cancelar(p) {
        if (!p.id_pedido) {
          return;
        }

        this.load = true;
        const url = this.origin === '2' ? `${p.token}/` : this.$helpers.base_url(this, this.empresa, p);

        this.$http.post(url + this.token + '/meus-pedidos/cancelar', p, {emulateJSON: true})
          .then(res => {
            if (res.data && res.data.success) {
              this.$swal("Pedido cancelado com sucesso!");

            } else {
              let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
              this.$swal(msg);
            }

            this.load = false;
            this.$emit('atualizar');

          }, res => {
            this.load = false;
            if (res.status === 401 && res.data.result !== '') {
              this.$swal(res.data.result + ' ' + res.data.msg).then(() => {
                this.$store.commit('logout');
                this.$router.push(this.url + '/perfil');
              });
            } else {
              let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
              this.$swal(msg);
              this.$emit('atualizar');
            }
          });
      },

      enviarWhatsapp(p) {
        const tel = '55' + p.whatsapp;
        const msg = '# Olá, enviei um pedido mas ainda não foi confirmado. Poderia dar uma olhada por favor? \nPedido: *' + p.id_contador + '* \nRealizado às: *' + p.data_pedido + '* \n\nVia LeCard Delivery';
        window.open('https://api.whatsapp.com/send?phone='+ tel +'&text=' + window.encodeURIComponent(msg), '_blank');
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      zap() {
        return this.$store.state.zap
      }
    },

    filters: {
      phone(phone) {
        if (phone) {
          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone
      }
    }
  }
</script>

<style scoped>
  svg {
    fill: currentColor;
  }
  .loader {
    height: 4px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: #ddd;
  }
  .loader:before {
    display: block;
    position: absolute;
    content: "";
    left: -200px;
    width: 200px;
    height: 4px;
    background-color: var(--lecard-primary);
    animation: loading 2s linear infinite;
  }
  .loader.t-50:before {
    background-color: #28a745;
    left: 0;
    width: 0;
    animation: avancar-33 2s linear infinite;
  }
  .loader.t-100:before {
    background-color: #343a40;
    left: 0;
    width: 50%;
    animation: avancar-66 2s linear infinite;
  }
  @keyframes loading {
    from {left: -200px; width: 30%;}
    50% {width: 30%;}
    70% {width: 70%;}
    80% { left: 50%;}
    95% {left: 120%;}
    to {left: 100%;}
  }
  @keyframes avancar-33 {
    from {width: 0;}
    to {width: 50%}
  }
  @keyframes avancar-66 {
    from {width: 50%;}
    to {width: 100%}
  }
</style>
